import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getEmbeddingsModelsAction, getEmbeddingsVectorsAction } from "./actions";
import type { EmbeddingsState } from "./types";

export function getEmbeddingsModelsReducerBuilder(
  builder: ActionReducerMapBuilder<EmbeddingsState>
) {
  builder.addCase(getEmbeddingsModelsAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getEmbeddingsModelsAction.fulfilled, (state, action) => {
    state.models = action.payload;
    state.isLoading = false;
  });
  builder.addCase(getEmbeddingsModelsAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function getEmbeddingsVectorsReducerBuilder(
  builder: ActionReducerMapBuilder<EmbeddingsState>
) {
  builder.addCase(getEmbeddingsVectorsAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getEmbeddingsVectorsAction.fulfilled, (state, action) => {
    state.vectors = action.payload;
    state.isLoading = false;
  });
  builder.addCase(getEmbeddingsVectorsAction.rejected, (state) => {
    state.isLoading = false;
  });
}